import { useMutation } from '@apollo/client';
import NEW_FLASHCARD_DECK from 'graphql/fragments/NewFlashcardDeck.graphql';
import CREATE_FLASHCARD_DECK from 'graphql/mutations/flashcardDecks/CreateFlashcardDeck.graphql';

export default function useCreateFlashcardDeckMutation() {
  return useMutation(CREATE_FLASHCARD_DECK, {
    update(cache, { data: { createFlashcardDeck } }) {
      cache.modify({
        fields: {
          flashcardDecksByEpub(existingFlashcardDecks) {
            const newFlashcardDeckRef = cache.writeFragment({
              data: createFlashcardDeck.flashcardDeck,
              fragment: NEW_FLASHCARD_DECK,
            });

            return {
              __typename: existingFlashcardDecks.__typeName,
              edges: [
                ...existingFlashcardDecks.edges,
                {
                  __typename: 'FlashcardDeckNodeEdge',
                  node: newFlashcardDeckRef,
                },
              ],
            };
          },
        },
      });
    },
  });
}
